/* ÉLORIA 2026 — interactions */
(() => {
  'use strict';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasIO = 'IntersectionObserver' in window;
  /* Fiche produit par défaut quand la page n'a pas de bloc d'achat (accueil) */
  const PDP = root + 'products/culotte-sculpt-360-noir';
  /* Même format que les prix affichés par la boutique (€34,90) */
  const fmt = (c) => '€' + (c / 100).toFixed(2).replace('.', ',');
  document.documentElement.classList.add('e-js');

  /* ---------- Bloc d'achat + sélecteur de lots ---------- */
  function initBuy(box) {
    let data;
    try { data = JSON.parse(box.querySelector('[data-e-json]').textContent); } catch (e) { return; }
    const swap = box.dataset.swap === 'true';
    let color = box.dataset.color;
    let size = null;
    const $ = (s) => box.querySelector(s);
    const sizesEl = $('[data-e-sizes]');
    const btn = $('[data-e-add]');
    const msg = $('[data-e-msg]');
    const img = $('[data-e-img]');
    const cname = $('[data-e-cname]');
    const piecesEl = $('[data-e-pieces]');
    const plist = $('[data-e-plist]');
    const sec = box.closest('.e-buysec');
    if (!data[color] || !sizesEl || !btn) return;
    const handles = Object.keys(data);
    const cur = () => data[color];
    const qty = () => { const c = box.querySelector('[data-e-qty]:checked'); return c ? parseInt(c.value, 10) : 1; };
    const find = (h, t) => (data[h] ? data[h].variants.find((v) => v.t === t && v.a) : null);
    const paint = () => { if (sec && cur().tint) sec.style.backgroundColor = cur().tint; };
    /* pièces du lot : { c: handle, s: taille, own: taille choisie à la main } */
    let pieces = [];

    function syncPieces() {
      const n = qty();
      while (pieces.length < n) pieces.push({ c: color, s: size, own: false });
      pieces.length = n;
      pieces.forEach((p) => { if (!p.own) p.s = size; if (p.s && !find(p.c, p.s)) p.s = null; });
    }
    function drawPieces() {
      if (!piecesEl || !plist) return;
      const n = qty();
      piecesEl.hidden = n < 2;
      if (n < 2) { plist.textContent = ''; return; }
      const sizes = cur().variants.map((v) => v.t);
      plist.textContent = '';
      pieces.forEach((p, i) => {
        const li = document.createElement('li'); li.className = 'e-piece';
        const num = document.createElement('span'); num.className = 'e-piece__n';
        num.append('Culotte ' + (i + 1) + ' : ');
        const nb = document.createElement('b'); nb.textContent = data[p.c].name + (p.s ? ', taille ' + p.s : ''); num.append(nb);
        li.append(num);
        const cols = document.createElement('div'); cols.className = 'e-piece__cols'; cols.setAttribute('role', 'group'); cols.setAttribute('aria-label', 'Couleur de la culotte ' + (i + 1));
        handles.forEach((h) => {
          const b = document.createElement('button'); b.type = 'button'; b.className = 'e-piece__c';
          const dot = document.createElement('span'); dot.className = 'e-piece__dot'; dot.style.backgroundColor = data[h].hex || '#999'; b.append(dot);
          b.setAttribute('aria-label', data[h].name); b.title = data[h].name;
          b.setAttribute('aria-pressed', String(p.c === h));
          b.addEventListener('click', () => { p.c = h; if (p.s && !find(h, p.s)) p.s = null; drawPieces(); update(); });
          cols.append(b);
        });
        li.append(cols);
        const sel = document.createElement('select'); sel.setAttribute('aria-label', 'Taille de la culotte ' + (i + 1));
        const o0 = document.createElement('option'); o0.value = ''; o0.textContent = 'Taille'; sel.append(o0);
        sizes.forEach((t) => { const o = document.createElement('option'); o.value = t; o.textContent = t; o.disabled = !find(p.c, t); sel.append(o); });
        sel.value = p.s || '';
        sel.addEventListener('change', () => { p.s = sel.value || null; p.own = true; sel.classList.remove('is-missing'); nb.textContent = data[p.c].name + (p.s ? ', taille ' + p.s : ''); update(); });
        li.append(sel);
        plist.append(li);
      });
    }
    function drawSizes() {
      if (size && !find(color, size)) size = null;
      sizesEl.querySelectorAll('button[data-size]').forEach((b) => {
        const ok = !!find(color, b.dataset.size);
        b.disabled = !ok;
        b.setAttribute('aria-pressed', String(ok && b.dataset.size === size));
      });
    }
    function ready() { return pieces.length && pieces.every((p) => p.s && find(p.c, p.s)); }
    function update() {
      const q = qty();
      /* Total du lot : fourni par le bloc d'achat (data-total, en centimes) */
      const ck = box.querySelector('[data-e-qty]:checked');
      const total = ck && ck.dataset.total ? parseInt(ck.dataset.total, 10) : cur().price * q;
      if (ready()) btn.textContent = (q > 1 ? 'Ajouter ' + q + ' culottes' : 'Ajouter au panier') + ' · ' + fmt(total);
      else btn.textContent = size ? 'Choisissez la taille de chaque culotte' : 'Choisissez votre taille';
      msg.textContent = '';
    }
    function refresh() { syncPieces(); drawPieces(); update(); }

    sizesEl.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-size]');
      if (!b || b.disabled) return;
      size = b.dataset.size;
      drawSizes();
      refresh();
    });
    box.querySelectorAll('[data-e-qty]').forEach((i) => i.addEventListener('change', refresh));
    box.querySelectorAll('[data-e-sw]').forEach((a) => a.addEventListener('click', (e) => {
      if (!swap || !data[a.dataset.eSw]) return;
      e.preventDefault();
      const old = color;
      color = a.dataset.eSw;
      pieces.forEach((p) => { if (p.c === old) p.c = color; });
      box.querySelectorAll('[data-e-sw]').forEach((x) => x.setAttribute('aria-current', String(x === a)));
      if (cname) cname.textContent = cur().name;
      paint();
      if (img && cur().img) {
        img.style.opacity = '0';
        const n = new Image();
        n.onload = () => { img.removeAttribute('srcset'); img.src = cur().img; img.alt = 'Culotte Sculpt 360° ' + cur().name.toLowerCase() + ' portée'; img.style.opacity = '1'; };
        n.src = cur().img;
      }
      drawSizes();
      refresh();
    }));
    btn.addEventListener('click', async () => {
      if (!ready()) {
        if (!size) {
          msg.textContent = 'Choisissez d’abord votre taille.';
          sizesEl.classList.remove('is-shake'); void sizesEl.offsetWidth; sizesEl.classList.add('is-shake');
          const first = sizesEl.querySelector('button:not(:disabled)'); if (first) first.focus();
        } else {
          msg.textContent = 'Indiquez la taille de chaque culotte.';
          const miss = plist ? Array.from(plist.querySelectorAll('select')).filter((s) => !s.value) : [];
          miss.forEach((s) => s.classList.add('is-missing'));
          if (miss[0]) miss[0].focus();
        }
        return;
      }
      const agg = {};
      pieces.forEach((p) => { const v = find(p.c, p.s); agg[v.id] = (agg[v.id] || 0) + 1; });
      const items = Object.keys(agg).map((id) => ({ id: Number(id), quantity: agg[id] }));
      btn.classList.add('is-wait');
      btn.textContent = 'Ajout en cours…';
      try {
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || ''); }
        window.location.href = root + 'cart';
      } catch (err) {
        btn.classList.remove('is-wait');
        update();
        msg.textContent = err.message || 'Impossible d’ajouter au panier. Réessayez dans un instant.';
      }
    });
    if (swap) paint();
    /* Taille présélectionnée depuis l'accueil (?taille=L) */
    try {
      const want = new URLSearchParams(window.location.search).get('taille');
      if (want && find(color, want)) size = want;
    } catch (e) { /* ignore */ }
    drawSizes();
    refresh();
  }

  /* ---------- Calculateur de taille (par poids) ---------- */
  function initCalc(w) {
    const rows = Array.from(w.querySelectorAll('tr[data-s]'));
    const ik = w.querySelector('[data-e-kg]');
    const out = w.querySelector('[data-e-out]');
    if (!ik || !out || !rows.length) return;
    const range = (r) => r.dataset.kg.split('-').map(parseFloat);
    const last = rows.length - 1;
    const lo = range(rows[0])[0];
    const hi = range(rows[last])[1];
    function show(n, note) {
      const s = rows[n].dataset.s;
      rows[n].classList.add('is-hit');
      out.append('Taille conseillée : ');
      const t = document.createElement('b'); t.textContent = s; out.append(t);
      if (note) { const h = document.createElement('span'); h.textContent = note; out.append(h); }
      const buy = w.closest('[data-e-buy]');
      if (buy) {
        const go = document.createElement('button');
        go.type = 'button';
        go.textContent = 'Choisir ' + s;
        go.addEventListener('click', () => {
          const sb = Array.from(buy.querySelectorAll('button[data-size]')).find((x) => x.dataset.size === s);
          if (!sb || sb.disabled) return;
          sb.click();
          const d = w.closest('details'); if (d) d.open = false;
          sb.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        });
        out.append(go);
      } else {
        const l = document.createElement('a');
        l.href = document.getElementById('acheter') ? '#acheter' : PDP + '?taille=' + encodeURIComponent(s);
        l.textContent = 'Commander en ' + s;
        out.append(l);
      }
    }
    function run() {
      rows.forEach((r) => r.classList.remove('is-hit'));
      out.textContent = '';
      const v = parseFloat(String(ik.value).replace(',', '.'));
      if (isNaN(v) || v <= 0) return;
      if (v > hi) { out.textContent = 'Au-delà de ' + hi + ' kg, écrivez-nous : nous vérifions la bonne taille avec vous.'; return; }
      let n = rows.findIndex((r, k) => { const mx = range(r)[1]; return k === last ? v <= mx : v < mx; });
      if (n < 0) n = last;
      show(n, v < lo ? '(elle peut être un peu ample)' : '');
    }
    ik.addEventListener('input', run);
  }

  /* ---------- Vue 360 ---------- */
  function initSpin(st) {
    const imgs = Array.from(st.querySelectorAll('img'));
    const hots = Array.from(st.querySelectorAll('[data-on]'));
    const lab = st.querySelector('[data-e-spin-l]');
    if (imgs.length < 2) return;
    let i = 0; let auto = null; let touched = false; let x0 = null;
    const show = (n) => {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach((m, k) => m.classList.toggle('is-on', k === i));
      hots.forEach((h) => h.classList.toggle('is-on', h.dataset.on.split(',').indexOf(String(i)) > -1));
      if (lab) lab.textContent = imgs[i].dataset.label || '';
    };
    const stop = () => { touched = true; clearInterval(auto); };
    st.querySelectorAll('[data-dir]').forEach((b) => b.addEventListener('click', (e) => { e.stopPropagation(); stop(); show(i + (b.dataset.dir === 'next' ? 1 : -1)); }));
    st.addEventListener('pointerdown', (e) => { if (e.target.closest('button')) return; x0 = e.clientX; stop(); });
    st.addEventListener('pointermove', (e) => { if (x0 === null) return; const dx = e.clientX - x0; if (Math.abs(dx) > 36) { show(i + (dx < 0 ? 1 : -1)); x0 = e.clientX; } });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((t) => st.addEventListener(t, () => { x0 = null; }));
    st.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { stop(); show(i + 1); } if (e.key === 'ArrowLeft') { stop(); show(i - 1); } });
    if (!reduce && hasIO) {
      new IntersectionObserver((es) => {
        if (touched) return;
        clearInterval(auto);
        if (es[0].isIntersecting) auto = setInterval(() => show(i + 1), 1500);
      }, { threshold: 0.5 }).observe(st);
    }
    show(0);
  }

  /* ---------- Récit au défilement ---------- */
  function initStory(s) {
    const imgs = s.querySelectorAll('[data-e-story-img]');
    const steps = s.querySelectorAll('[data-e-step]');
    if (!hasIO || !steps.length) return;
    const set = (n) => {
      imgs.forEach((m, k) => m.classList.toggle('is-on', k === n));
      steps.forEach((m, k) => m.classList.toggle('is-on', k === n));
    };
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) set(parseInt(e.target.dataset.eStep, 10)); }), { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach((st) => io.observe(st));
  }

  /* ---------- Vidéos chargées à la demande ---------- */
  function initVideos() {
    const vids = document.querySelectorAll('video[data-e-lazy]');
    if (!vids.length) return;
    const load = (v) => { if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src; };
    if (reduce || !hasIO) { vids.forEach((v) => { load(v); v.controls = true; }); return; }
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { load(v); const p = v.play(); if (p && p.catch) p.catch(() => {}); } else { v.pause(); }
    }), { threshold: 0.35 });
    vids.forEach((v) => io.observe(v));
  }

  /* ---------- Apparitions au défilement ---------- */
  function initReveal() {
    if (reduce || !hasIO) return;
    document.documentElement.classList.add('e-anim');
    const sel = '.e-head, .e-ben__item, .e-sa__item, .e-cmp__img, .e-table, .e-card, .e-steps li, .e-vid figure, .e-spin__stage, .e-buy__media, .e-faq__grid > div:first-child, .e-legend li';
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll(sel).forEach((el) => {
      const sibs = el.parentElement ? Array.from(el.parentElement.children) : [];
      el.style.transitionDelay = (Math.min(sibs.indexOf(el), 4) * 80) + 'ms';
      el.classList.add('e-rv');
      io.observe(el);
    });
  }

  /* ---------- Barre d'achat mobile, galeries ---------- */
  function initSticky() {
    const bar = document.querySelector('[data-e-sticky]');
    if (!bar) return;
    const buy = document.querySelector('[data-e-buy]');
    const foot = document.querySelector('.e-fin');
    let buyIn = false; let footIn = false;
    const tick = () => bar.classList.toggle('is-on', window.scrollY > 560 && !buyIn && !footIn);
    if (hasIO && buy) new IntersectionObserver((es) => { buyIn = es[0].isIntersecting; tick(); }).observe(buy);
    if (hasIO && foot) new IntersectionObserver((es) => { footIn = es[0].isIntersecting; tick(); }).observe(foot);
    window.addEventListener('scroll', tick, { passive: true });
  }
  function initGalleries() {
    document.querySelectorAll('[data-e-gal]').forEach((g) => {
      const out = g.parentElement.querySelector('[data-e-gal-i]');
      if (!out) return;
      g.addEventListener('scroll', () => { out.textContent = String(Math.round(g.scrollLeft / g.clientWidth) + 1); }, { passive: true });
    });
    document.querySelectorAll('[data-e-arrows]').forEach((w) => {
      const row = document.getElementById(w.dataset.eArrows);
      if (!row) return;
      w.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => {
        row.scrollBy({ left: (b.dataset.dir === 'next' ? 1 : -1) * row.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
      }));
    });
    if (reduce) document.querySelectorAll('.e video[autoplay]').forEach((v) => { v.pause(); v.controls = true; });
  }

  /* Colonne d'achat fixe (ordinateur) : si elle est plus haute que l'écran,
     on la laisse défiler jusqu'à son bouton avant de la figer. */
  function initInfoSticky() {
    const info = document.querySelector('.e-pdp__info');
    if (!info) return;
    const fit = () => {
      info.style.top = '';
      if (getComputedStyle(info).position !== 'sticky') return;
      const top = parseFloat(getComputedStyle(info).top) || 0;
      const over = info.offsetHeight + top + 24 - window.innerHeight;
      if (over > 0) info.style.top = (top - over) + 'px';
    };
    fit();
    window.addEventListener('resize', fit, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(info);
  }

  function init() {
    initInfoSticky();
    document.querySelectorAll('[data-e-buy]').forEach(initBuy);
    document.querySelectorAll('[data-e-sg]').forEach(initCalc);
    document.querySelectorAll('[data-e-spin]').forEach(initSpin);
    document.querySelectorAll('[data-e-story]').forEach(initStory);
    initVideos();
    initReveal();
    initSticky();
    initGalleries();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
